<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">
          <v-skeleton-loader v-if='loadingdata' :loading="loadingdata" type="table">
          </v-skeleton-loader>
          <DataTable v-else
            @editing="editing"
            @deleting="deleting"
            :title="''"
            :actiontitle="'Personal Template' | translate"
            :headers="headers"
            :items="personaldocuments"
          />
          <Dialogbox
            @closing="closing"
            @deleteuser="personalDocumentDelete"
            :title="dialogboxtitle"
            :dialog="dialogstatus"
            :deleteuser="true"
            :buttonTitle="dialogButtontitle"
            v-if="dialogstatus"
          />  
        </v-col>
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="addPersonalDocument">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import {
  FETCH_PERSONAL_DOCUMENTS,
  DELETE_PERSONAL_DOCUMENT,
  RESET_STATE
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import store from "@/store"
import { mapState } from "vuex";
import { SET_LOADING } from "@/store/mutations.type";

export default {
  name: "PersonalTemplate",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_PERSONAL_DOCUMENTS, "").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
      }
    });
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["personaldocuments", 'loadingdata', 'currentUser']),
    ...mapState({
      errors: state => state.documents.documenterrors
    }),
    headers(){
      return [
        { text: this.$t("Name"), value: "temp_name" },
        { text: this.$t("Validity"), value: "temp_validity" },
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    },
    canAdd(){
      if(typeof (this.currentUser) !== 'undefined') {
        if(this.currentUser.roles.includes(1) || this.currentUser.permissions.includes('can-create-personal-template')){
          return true;
        }
      }
      return false;
    },    
  },
  data: function() {
    return {
      title: "Personal Template",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,  
      personaldocumentdeleteid: null,       
    };
  },
  created (){
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }
  },
  methods: {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('can-create-personal-template') || this.currentUser.permissions.includes('can-update-personal-template') || this.currentUser.permissions.includes('can-delete-personal-template') ){
        return true;
      }
      return false;
    },
    editing(id) {
      this.$router.push("/personal-template/edit/" + id);
    },
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.personaldocumentdeleteid = id
    },
    closing(){      
      this.dialogstatus = false
      this.personaldocumentdeleteid = ''
      this.dialogboxtitle = ''
      this.dialogButtontitle =  ''     
    },    
    async personalDocumentDelete() {
      await store.dispatch(DELETE_PERSONAL_DOCUMENT, this.personaldocumentdeleteid).then(resp => {
        if (resp !== undefined && resp.success) {
          this.personaldocumentdeleteid = null
          store.dispatch(FETCH_PERSONAL_DOCUMENTS).then(resp => {
            if (resp.success) {
              store.commit(SET_LOADING, false)
              this.dialogstatus = false

            }
          });
        }
        else if(resp == undefined && this.errors.success ==false){
              this.dialogstatus = false
              store.commit(SET_LOADING, false)
              this.personaldocumentdeleteid = null
              this.dialogboxtitle = this.errors.message
              this.dialogButtontitle = ""              
              this.dialogstatus = true

            }
      })
    },
    addPersonalDocument() {
      this.$router.push("/personal-template/add/");
    }
  }
};
</script>